import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import SalesInfoActions from "../../../components/User//SaledInformationComponents/SalesInfoActions";
import SalesInfoTable from "../../../components/User//SaledInformationComponents/SalesInfoTable";

const { getRestaurants } = appActions;

const SalesInformation = () => {
  const { selectedOrganization } = useProjectState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <div>
      <PageHeader text="Справка по асортименти" date={true} />
      <SalesInfoActions />
      <SalesInfoTable />
    </div>
  );
};

export default SalesInformation;
